<template>
  <div class="page-container">
    <div class="query-title">经销商分流任意客户权限配置</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
        <template #button>
            <table-button name="export" tip="新增" @click="dialogVisible=true" />
            <table-button name="export" tip="删除" @click="deleShuntAnyClient" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
          </vxe-grid>
        </Table-filter>
      </div>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <ClientSelect ref="dialogSelect" :isRadio="isRadio"/>
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {findShuntAnyClientsQuery, deleShuntAnyClient, saveShuntAnyClient} from '@/api/signing'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/shuntCustomLimits'
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
export default {
  mixins: [tableMixins],
  components: { ClientSelect },
  data() {
    return {
      showBtn: '',
      conditions: {
        templateCode: '',
        batchNumber: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
        ],
        columns: [
          { type: 'checkbox', title: '', width: 50, field: 'checkbox' }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      dialogVisible: false,
      isRadio: false,

    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    // 新增
    async submitHandle(){
      const data = await this.$refs.dialogSelect.submitForm()
      console.log(`output-data`,data)
      const customerCodes = []
      data.forEach(ele => {
        customerCodes.push(ele.partner)
      });
      const res = await saveShuntAnyClient(customerCodes)
      if(res.data && res.data.status - 0 === 1){
        this.dialogVisible = false
        Message.success('添加成功')
        this.queryData()
      }else{
        return Message.warning(res.message)
      }
    },
    // 删除
    async deleShuntAnyClient(){
      const checkData = this.$refs.xTable.getCheckboxRecords()
      const customerCodes = []
      if (checkData.length) {
        checkData.forEach(ele => {
          customerCodes.push(ele.customerCode)
        });
        const res = await deleShuntAnyClient(customerCodes)
        if(res.data && res.data.status - 0 === 1){
          Message.success('删除成功')
          this.queryData()
        }else{
          return Message.warning(res.message)
        }
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        // sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await findShuntAnyClientsQuery(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  .el-dropdown{
    font-size: 12px;
    padding-left: 10px;
    color: #333;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/shuntCustomLimits.vue